import { useLocation } from 'react-router-dom';
import { AppRoute } from '../constants';

const normalizePathname = (pathname: string): string => {
  if (!pathname) return AppRoute.ROOT;
  if (pathname === AppRoute.ROOT) return pathname;
  return pathname.replace(/\/+$/, '');
};

const pathnameIsAppRoute = (pathname: string): pathname is AppRoute => {
  const routes: string[] = Object.values(AppRoute);
  return routes.includes(pathname);
};

const getRouteFromPathname = (pathname: string): AppRoute => {
  if (pathnameIsAppRoute(pathname)) return pathname;

  const matchedRoute = Object.values(AppRoute)
    .filter((route) => route !== AppRoute.ROOT)
    .find((route) => pathname.endsWith(route));

  return matchedRoute || AppRoute.ROOT;
};

/**
 * @returns The current AppRoute or AppRoute.ROOT if the current path is not an AppRoute.
 */
export const useCurrentRoute = (): AppRoute => {
  const { pathname } = useLocation();
  const normalizedPathname = normalizePathname(pathname);

  return getRouteFromPathname(normalizedPathname);
};
